/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Peughouia's Portfolio",
  description:
    "Développeur passionné, je conçois des produits de bout en bout en alliant performance, évolutivité et innovation pour bâtir des systèmes techniques durables.",
  og: {
    title: "Portfolio",
    type: "website",
    url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Fred Peughouia",
  logo_name: "PeughouiaFred",
  nickname: "Peugh's",
  subTitle:
    "Développeur passionné, je conçois des produits de bout en bout en alliant performance, évolutivité et innovation pour bâtir des systèmes techniques durables.",
  resumeLink:
    "https://drive.google.com/file/d/1Sm88cLLu6Hi2ilv6VsSlnhr9IrqBj0aX/view?usp=drive_link",
  portfolio_repository: "https://github.com/peughouia",
  githubProfile: "https://github.com/peughouia",
};

const socialMediaLinks = [
  /* Your Social Media Link */

  {
    name: "Github",
    link: "https://github.com/peughouia",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/fred-peughouia-a9b022228/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:peughouiafred@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://x.com/peughouiaf?s=21&t=UwEpke4bS_gJICDiCwnXGA",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
];

const skills = {
  data: [
    // {
    //   title: "Data Science & AI",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
    //     "⚡ Experience of working with Computer Vision and NLP projects",
    //     "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Keras",
    //       fontAwesomeClassname: "simple-icons:keras",
    //       style: {
    //         backgroundColor: "white",
    //         color: "#D00000",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //     {
    //       skillName: "Deeplearning",
    //       imageSrc: "deeplearning_ai_logo.png",
    //     },
    //   ],
    // },
    {
      title: "Développement Full Stack",
      fileName: "FullStackImg",
      skills: [
        "⚡ Création d’interfaces web responsives avec React.js et Tailwind CSS",
        "⚡ Développement d’applications mobiles avec React Native",
        "⚡ Conception et intégration de backends et d’API REST avec Python Django",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "TailwindCSS",
          fontAwesomeClassname: "devicon:tailwindcss",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "devicon:python",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "logos:django",
          style: {
            color: "#2C8EBB",
          },
        },

        {
          skillName: "Django REST Framework",
          fontAwesomeClassname: "devicon:djangorest",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "CI/CD, Déploiement & Hébergement d’applications",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Expérience de travail en equipe avec des outils de versioning comme Git, GitHub et GitLab",
        "⚡ Hébergement et maintenance d’applications web sur des machines virtuelles, avec intégration de bases de données",
        "⚡ Deploiement en continu sur des serveur distants tels que Vercel, pythonanywhere et Heroku",
      ],
      softwareSkills: [
        {
          skillName: "pythonanywhere",
          fontAwesomeClassname: "simple-icons:pythonanywhere",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "vercel",
          fontAwesomeClassname: "logos:vercel",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },

        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "git",
          fontAwesomeClassname: "devicon:git",
          style: {
            color: "#663399",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Conception d’interfaces utilisateur modernes et attractives pour les applications web et mobiles",
        "⚡ Création et personnalisation de logos uniques",
        "⚡ Définition du parcours utilisateur et des flux fonctionnels afin d’optimiser l’expérience et l’ergonomie des applications",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "canva",
          fontAwesomeClassname: "lineicons:canva",
          style: {
            color: "#007FFF",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "udemy",
      iconifyClassname: "logos:udemy",
      style: {
        color: "#F79F1B",
      },
      profileLink:
        "https://www.udemy.com/course/developpeur-python-formation-complete/",
    },
    {
      siteName: "Aws",
      iconifyClassname: "logos:aws",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://aws.amazon.com/fr/certification/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Expert en Architecture et developpement Logiciel (EADL)",
      subtitle: "",
      logo_path: "3il.png",
      alt_name: "Groupe 3IL",
      duration: "En cours (2025 - 2027)",
      descriptions: [
        "⚡ce programme de master vise à former des experts en architecture et développement logiciel, capables de concevoir, développer et maintenir des systèmes logiciels complexes et évolutifs. ainsi que de maîtriser les technologies et les méthodologies de pointe dans le domaine du développement logiciel.",
      ],
      website_link: "https://www.3il-ingenieurs.fr/",
    },
    {
      title: "Barchelor en conception des systèmes d'information (CSI)",
      subtitle: "Developpement des Logiciels Web (DLW)",
      logo_path: "iuc.png",
      alt_name: "Institut universitaire de la cote",
      duration: "2024 - 2025",
      descriptions: [
        "⚡ J'ai suivi divers cours portant sur la modélisation des systèmes d'information, la gestion des systèmes d'information, la gestion de projets et la gestion d'équipe, entre autres.",
        "⚡ En complément, j'ai étudié les architectures logicielles, leur mise en œuvre, la manipulation d’API web, l’interaction avec les bases de données en SQL ainsi que les principes d’ergonomie des applications.",
        "⚡ Au cours de cette année de licence, j’ai appris et maîtrisé la conception d’applications à architecture découplée (frontend et backend) ainsi que leur déploiement sur des serveurs distants.",
      ],
      website_link: "https://myiuc.com/",
    },
     {
      title: "Diplomes d'etude collégiale (DEC)",
      subtitle: "Programmations et applications mobiles (PAM)",
      logo_path: "iuc.png",
      alt_name: "Institut universitaire de la cote",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ J'ai étudié les fondamentaux du génie logiciel, notamment les algorithmes, les systèmes de gestion de bases de données (SGBD), les systèmes d'exploitation, la réseautique, ainsi que la rédaction technique, la communication en affaires et bien plus encore",
        "⚡ En complément, j'ai suivi des cours sur la conception logicielle, la programmation orientée objet (POO), le développement mobile, le développement web et le développement d’applications desktop.",
        "⚡ Dans le cadre de l’obtention de mon diplôme, j’ai également réalisé un projet de fin d’études portant sur la conception d’une application mobile de CVthèque, pour lequel j’ai obtenu la mention « Excellente »",
      ],
      website_link: "https://myiuc.com/",
    },  
  ],
};

const certifications = {
  certifications: [
    // {
    //   title: "Machine Learning",
    //   subtitle: "- Andrew Ng",
    //   logo_path: "stanford_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
    //   alt_name: "Stanford University",
    //   color_code: "#8C151599",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Travail, stage et projets",
  description:
    "J’ai travaillé sur plusieurs projets en tant que développeur, concepteur et architecte logiciel, aussi bien dans le cadre de stages que de collaborations personnelles.J’aime explorer toutes les dimensions du développement — du backend à l’infrastructure réseau — et participer à la création de solutions concrètes.",
  header_image_path: "experience.svg",
  sections: [
    // {
    //   title: "Travails",
    //   work: true,
    //   experiences: [
    //     {
    //       title: "Android Developer",
    //       company: "FreeCopy Pvt. Ltd.",
    //       company_url: "https://www.linkedin.com/company/freecopy/about/",
    //       logo_path: "freecopy_logo.png",
    //       duration: "Nov 2017 - Dec 2017",
    //       location: "Ahmedabad, Gujarat",
    //       description:
    //         "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
    //       color: "#fc1f20",
    //     },
    //   ],
    // },
    {
      title: "Stage et projets",
      work: true,
      experiences: [
        {
          title: "Developpeur Full Stack (Stage)",
          company: "Institut universitaire de la cote.",
          company_url: "https://myiuc.com/",
          logo_path: "iuc.png",
          duration: "dec 2024 - avr 2025",
          location: "Douala, CMR",
          description:
            "Conception et Développement Full stack(Backend-Django python, Frontend-React Js) d'une application web de gestion de reservation d'hebergement pour les clients d'hotel et gérant d'hotel",
          color: "#000000",
        },
        {
          title: "Developpeur Full Stack Mobile(stage)",
          company: "localhost Digital",
          company_url: "https://localhost-digital.com/",
          logo_path: "localhost.webp",
          duration: "juillet 2023",
          location: "Douala, Cameroun",
          description:
            "FindTalents est une application mobile CVthèque permettant a des personnes de retrouver des profils adéquat pour une taches ou job sans difficulté. ces profils seront créer a partir de la platform  par ceux proposant des services. en bonus ils pourront créer leur CV a partir de l'app afin d'appuyer leur profils",
          color: "#ee3c26",
        },
        {
          title: "Technicien systèmes et réseaux (Stage)",
          company: "Quiferou Cameroun",
          company_url: "https://groupequifeurou.com/",
          logo_path: "quiferou.jpeg",
          duration: "juillet 2019",
          location: "Bafoussam, Cameroun",
          description:
            "Assistant dans la maintenance et l'installation des équipements informatiques(materiel et logiciel) et réseau au sein de l'entreprise",
          color: "#0071C5",
        },
      ],
    },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Google Explore ML Facilitator",
    //       company: "Google",
    //       company_url: "https://about.google/",
    //       logo_path: "google_logo.png",
    //       duration: "June 2019 - April 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Microsoft Student Partner",
    //       company: "Microsoft",
    //       company_url: "https://www.microsoft.com/",
    //       logo_path: "microsoft_logo.png",
    //       duration: "Aug 2019 - May 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Mozilla Campus Captain",
    //       company: "Mozilla",
    //       company_url: "https://www.mozilla.org/",
    //       logo_path: "mozilla_logo.png",
    //       duration: "Oct 2019 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Developer Students Club Member",
    //       company: "DSC IIITDM Kurnool",
    //       company_url:
    //         "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
    //       logo_path: "dsc_logo.png",
    //       duration: "Jan 2018 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
    //       color: "#0C9D58",
    //     },
    //     {
    //       title: "Developer Program Member",
    //       company: "Github",
    //       company_url: "https://github.com/",
    //       logo_path: "github_logo.png",
    //       duration: "July 2019 - PRESENT",
    //       location: "Work From Home",
    //       description:
    //         "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
    //       color: "#181717",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projets",
  description:
    "Mes projets couvrent un large éventail de technologies modernes, allant du développement web et mobile à la conception d’architectures logicielles découplées. J’aime créer des applications complètes — du backend à l’interface utilisateur — et les déployer sur des serveurs distants ou des environnements cloud pour offrir des solutions performantes et évolutives.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Quelques projets publiés parmis ceux que j'ai eu a realiser.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "Works_Deposit_Project",
      name: "Works Deposit Project",
      image: "worksdeposit.png",
      createdAt: "2025-02-03T00:00:00Z",
      description:
        "Works Deposit est une application web de gestion des devoirs académiques permettant aux étudiants de déposer leurs travaux en ligne et aux professeurs de les consulter, corriger et noter facilement.Développée avec Django REST Framework pour le backend et React.js (avec React Query) pour le frontend, l’application offre une interface fluide et moderne, ainsi qu’un système sécurisé de gestion des fichiers.",
      url: "https://works-deposit.vercel.app/",
    },
    {
      id: "Mining_Trade_Project",
      name: "Mining Trade Project",
      image: "miningtrade.png",
      createdAt: "2025-08-07T00:00:00Z",
      description:
        "Plateforme d’investissement et de location de machines de minage, intégrant un système de parrainage à 3 niveaux et des paiements via Stripe et Flutterwave — développée avec Django REST et React.js.",
      url: "https://www.miningtradeorg.fyi/",
    },
    {
      id: "TimeTableGenerator",
      name: "Time Table Generator",
      image: "miningtrade.png",
      createdAt: "2025-10-31T00:00:00Z",
      description:
        "Ce projet est une application React/Tailwind qui permet de créer visuellement un emploi du temps hebdomadaire récurrent et d'exporter le résultat au format **iCalendar (.ics)**, compatible avec la plupart des plateformes de calendrier (Google Calendar, Outlook, Apple Calendar, Thunderbird, etc.).",
      url: "https://time-table-generator-theta.vercel.app/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    //profile_image_path: "animated_ashutosh.png",
    profile_image_path: "peughouia2.jpg",
    description:
      "Je suis disponible sur la plupart des réseaux sociaux. Envoyez-moi un message ; je vous répondrai sous 24 heures. Je peux vous aider en conception d’applications web, Android/iOS, développement de Back et Front, architecture logicielle, CI/CD et hébergement d’applications.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Je prevoir documenter certaines de mes expériences dans mon parcours professionnel ainsi que partager certaines connaissances techniques.",
    link: "#",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Avenue des Ruchoux, 87000 Limoges, France",
    locality: "Limoges",
    country: "FRANCE",
    region: "Haute-Vienne",
    postalCode: "87000",
    streetAddress: "Avenue des ruchoux",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/w19WVa7SBzNA487R8",
  },
  phoneSection: {
    title: "My Phone Number",
    subtitle: "+33 07 58 58 20 34",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
